// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_FoldableWithIndex from "../Data.FoldableWithIndex/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Map_Ordered from "../Data.Map.Ordered/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_NamedParams from "../Data.NamedParams/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_OrderedMultiSet from "../Data.OrderedMultiSet/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Vault from "../Data.Vault/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_Form_Delayed from "../Restaumatic.Form.Delayed/index.js";
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_Errors from "../Restaumatic.Form.Errors/index.js";
import * as Restaumatic_Form_GenerateId from "../Restaumatic.Form.GenerateId/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic_Form_Query from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic_Form_Result from "../Restaumatic.Form.Result/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Form_Undoable from "../Restaumatic.Form.Undoable/index.js";
import * as Restaumatic_Form_WithExtra from "../Restaumatic.Form.WithExtra/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Extra from "../Specular.FRP.Extra/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_FRP_List from "../Specular.FRP.List/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_KeyedList from "../Specular.KeyedList/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unsafe_Reference from "../Unsafe.Reference/index.js";
import * as Unscramble from "../Unscramble/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Restaumatic_Form_TestHelpers.semigroupCode);
var pure = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_Result.applicativeResult);
var relax = /* #__PURE__ */ Restaumatic_Form_DynamicResult.relax();
var map = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_DynamicResult.functorDynamicResult);
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Base.bindDynamic);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var mapFlipped1 = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var apply = /* #__PURE__ */ Control_Apply.apply(Specular_FRP_Base.applyDynamic);
var map1 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var map2 = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_Result.functorResult);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Form_DynamicResult.applicativeDynamicResult);
var map3 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var bind2 = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Host.bindHost);
var discard2 = /* #__PURE__ */ discard(Specular_FRP_Host.bindHost);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_FRP_Host.monadEffectHost);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Host.applicativeHost);
var read = /* #__PURE__ */ Specular_Ref.read(Effect_Class.monadEffectEffect);
var forWithIndex_ = /* #__PURE__ */ Data_FoldableWithIndex.forWithIndex_(Effect.applicativeEffect)(Data_FoldableWithIndex.foldableWithIndexArray);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var fromFoldable = /* #__PURE__ */ Foreign_Object.fromFoldable(Data_Foldable.foldableArray);
var toAscUnfoldable = /* #__PURE__ */ Foreign_Object.toAscUnfoldable(Data_Unfoldable.unfoldableArray);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var pure3 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var map4 = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_Delayed.functorDelayed);
var readDelayed = /* #__PURE__ */ Restaumatic_Form_Delayed.readDelayed(Effect_Class.monadEffectEffect);
var read1 = /* #__PURE__ */ Specular_Ref.read(Specular_FRP_Host.monadEffectHost);
var traverse_ = /* #__PURE__ */ Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Map_Ordered.foldableOMap);
var $$for = /* #__PURE__ */ Data_Traversable["for"](Effect.applicativeEffect)(Data_Traversable.traversableArray);
var map5 = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var write = /* #__PURE__ */ Specular_Ref.write(Effect_Class.monadEffectEffect);
var modify = /* #__PURE__ */ Specular_Ref.modify(Effect_Class.monadEffectEffect);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var for_ = /* #__PURE__ */ Data_Foldable.for_(Effect.applicativeEffect);
var for_1 = /* #__PURE__ */ for_(Data_Foldable.foldableArray);
var pure4 = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_Delayed.applicativeDelayed);
var add = /* #__PURE__ */ Data_Numeric.add(Data_Numeric.additiveInt);
var recordEncode = /* #__PURE__ */ Foreign_Generic_Class.recordEncode();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var itemsIsSymbol = {
    reflectSymbol: function () {
        return "items";
    }
};
var encodeRecordCons2 = /* #__PURE__ */ encodeRecordCons1(itemsIsSymbol);
var subformIsSymbol = {
    reflectSymbol: function () {
        return "subform";
    }
};
var keyIsSymbol = {
    reflectSymbol: function () {
        return "key";
    }
};
var encodeRecordCons3 = /* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(subformIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.foreignEncode)))(keyIsSymbol);
var sequenceRecord = /* #__PURE__ */ Record_Extra.sequenceRecord();
var sequenceRecord1 = /* #__PURE__ */ sequenceRecord(/* #__PURE__ */ Record_Extra.sequenceRecordSingle(itemsIsSymbol)()(Specular_FRP_Base.functorDynamic)()());
var for1 = /* #__PURE__ */ Data_Traversable["for"](Specular_FRP_Base.applicativeDynamic)(Data_Traversable.traversableArray);
var sequenceRecord2 = /* #__PURE__ */ sequenceRecord(/* #__PURE__ */ Record_Extra.sequenceRecordCons(keyIsSymbol)()(Specular_FRP_Base.applyDynamic)(/* #__PURE__ */ Record_Extra.sequenceRecordSingle(subformIsSymbol)()(Specular_FRP_Base.functorDynamic)()())()());
var for_2 = /* #__PURE__ */ for_(Data_Foldable.foldableMaybe);
var $$new = /* #__PURE__ */ Specular_Ref["new"](Effect_Class.monadEffectEffect);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_Vault.monoidVault);
var fixDelayed = /* #__PURE__ */ Restaumatic_Form_Delayed.fixDelayed(Specular_FRP_Host.monadEffectHost);
var $$void = /* #__PURE__ */ Data_Functor["void"](Effect.functorEffect);
var append2 = /* #__PURE__ */ Data_Semigroup.append(Data_Vault.semigroupVault);
var readRef = /* #__PURE__ */ Specular_Ref.readRef(Effect_Class.monadEffectEffect);
var for_3 = /* #__PURE__ */ for_(Data_Map_Ordered.foldableOMap);
var LocalId = function (x) {
    return x;
};
var ListItem = function (x) {
    return x;
};
var List = function (x) {
    return x;
};
var DelayedItem = function (x) {
    return x;
};
var toRecordHelperList$prime = function (dictToHelper) {
    var fillFormFieldType = Restaumatic_Form_TestHelpers.fillFormFieldType(dictToHelper);
    var toHelperConstructor = Restaumatic_Form_TestHelpers.toHelperConstructor(dictToHelper);
    return {
        helperBaseClass: function (v) {
            return new Data_Maybe.Just(append(Restaumatic_Form_TestHelpers.lit("ListHelper<"))(append(Restaumatic_Form_TestHelpers.ppType(fillFormFieldType(Type_Proxy["Proxy"].value)))(Restaumatic_Form_TestHelpers.lit(">"))));
        },
        toHelperClassBody: function (v) {
            return append(Restaumatic_Form_TestHelpers.lit("item(key: string) { return new "))(append(toHelperConstructor(Type_Proxy["Proxy"].value))(Restaumatic_Form_TestHelpers.lit("(this.parent, this._name + '.' + key); }\x0a")));
        },
        ToHelper0: function () {
            return toHelperList$prime(dictToHelper);
        }
    };
};
var toHelperList$prime = function (dictToHelper) {
    var fillFormFieldType = Restaumatic_Form_TestHelpers.fillFormFieldType(dictToHelper);
    return {
        fillFormFieldType: function (v) {
            return Restaumatic_Form_TestHelpers.tyApp("FillFormList")([ fillFormFieldType(Type_Proxy["Proxy"].value) ]);
        },
        toHelperConstructor: function (p) {
            return Restaumatic_Form_TestHelpers.toRecordHelperConstructor(toRecordHelperList$prime(dictToHelper))(p);
        }
    };
};
var toFillFormTypeLocalId = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("number");
    }
};
var showLocalId = Data_Show.showInt;
var queryNonEmptyArrayList$primePa = function (dictQuery) {
    var queryImpl = Restaumatic_Form_Query.queryImpl(dictQuery);
    return {
        queryImpl: function (s) {
            return function (v) {
                return Restaumatic_Form_DynamicResult.over(function (v1) {
                    return Restaumatic_Form_Result.andThen(v1)(function (a) {
                        var v2 = Data_Array_NonEmpty.fromArray(a);
                        if (v2 instanceof Data_Maybe.Nothing) {
                            return Restaumatic_Form_Result.invalid(Restaumatic_Form_Internal.tagErrors(v.name)(Data_Maybe.Nothing.value)(Restaumatic_Form_Errors.userVisibleError(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required))));
                        };
                        if (v2 instanceof Data_Maybe.Just) {
                            return pure(v2.value0);
                        };
                        throw new Error("Failed pattern match at Restaumatic.Form.List (line 371, column 11 - line 373, column 31): " + [ v2.constructor.name ]);
                    });
                })(relax(queryImpl(s)(v)));
            };
        }
    };
};
var queryListItem = function (dictQuery) {
    var queryImpl = Restaumatic_Form_Query.queryImpl(dictQuery);
    return {
        queryImpl: function (s) {
            return function (v) {
                return queryImpl(s)(v.subform);
            };
        }
    };
};
var queryList$prime = function () {
    return function (dictQuery) {
        var queryImpl = Restaumatic_Form_Query.queryImpl(dictQuery);
        return {
            queryImpl: function (s) {
                return function (l) {
                    return map(wrap)(queryImpl(s)(l));
                };
            }
        };
    };
};
var queryArrayT2List$prime = function (dictOrd) {
    var mempty1 = Data_Monoid.mempty(Data_Map_Internal.monoidMap(dictOrd));
    var lookup = Data_Map_Internal.lookup(dictOrd);
    var fromFoldable1 = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray);
    return function (dictQuery) {
        var queryImpl = Restaumatic_Form_Query.queryImpl(dictQuery);
        return {
            queryImpl: function (s) {
                return function (v) {
                    return Effect_Unsafe.unsafePerformEffect(function __do() {
                        var cache = Effect_Ref["new"](mempty1)();
                        return Restaumatic_Form_DynamicResult.wrap(bind1(mapFlipped(Specular_Ref.value(v.items))(function (items$prime) {
                            return Effect_Unsafe.unsafePerformEffect(function __do() {
                                var cached = Effect_Ref.read(cache)();
                                return mapFlipped1(Data_Map_Ordered.values(items$prime))(function (v1) {
                                    return new Data_Tuple.Tuple(v1.key, (function () {
                                        var v2 = lookup(v1.key)(cached);
                                        if (v2 instanceof Data_Maybe.Just) {
                                            return v2.value0;
                                        };
                                        if (v2 instanceof Data_Maybe.Nothing) {
                                            return Restaumatic_Form_DynamicResult.wrap(apply(map1(function (v3) {
                                                return function (v4) {
                                                    if (v3) {
                                                        return map2((function () {
                                                            var $550 = Data_Tuple_T2.T2.create(v1.key);
                                                            return function ($551) {
                                                                return Data_Maybe.Just.create($550($551));
                                                            };
                                                        })())(v4);
                                                    };
                                                    return pure(Data_Maybe.Nothing.value);
                                                };
                                            })(v.presentWhen(v1)))(Restaumatic_Form_DynamicResult.unwrap(queryImpl(s)(v1.subform))));
                                        };
                                        throw new Error("Failed pattern match at Restaumatic.Form.List (line 341, column 13 - line 351, column 36): " + [ v2.constructor.name ]);
                                    })());
                                });
                            });
                        }))(function (queriedItems) {
                            return Effect_Unsafe.unsafePerformEffect(function __do() {
                                Effect_Ref.write(fromFoldable1(queriedItems))(cache)();
                                return Restaumatic_Form_DynamicResult.unwrap(map(Data_Array.catMaybes)(traverse(Data_Tuple.snd)(queriedItems)));
                            });
                        }));
                    });
                };
            }
        };
    };
};
var queryOMapList$prime = function (dictQuery) {
    return function (dictOrd) {
        var fromArray = Data_Map_Ordered.fromArray(dictOrd);
        var queryImpl = Restaumatic_Form_Query.queryImpl(queryArrayT2List$prime(dictOrd)(dictQuery));
        return {
            queryImpl: function (s) {
                return function (l) {
                    return map((function () {
                        var $552 = map3(Data_Tuple_T2.toTuple);
                        return function ($553) {
                            return fromArray($552($553));
                        };
                    })())(queryImpl(s)(l));
                };
            }
        };
    };
};
var queryMapList$prime = function (dictQuery) {
    var queryOMapList$prime1 = queryOMapList$prime(dictQuery);
    return function (dictOrd) {
        var queryImpl = Restaumatic_Form_Query.queryImpl(queryOMapList$prime1(dictOrd));
        return {
            queryImpl: function (s) {
                return function (l) {
                    return map(Data_Map_Ordered.toMap)(queryImpl(s)(l));
                };
            }
        };
    };
};
var queryArrayList$prime = function (dictOrd) {
    var queryArrayT2List$prime1 = queryArrayT2List$prime(dictOrd);
    return function (dictQuery) {
        var queryImpl = Restaumatic_Form_Query.queryImpl(queryArrayT2List$prime1(dictQuery));
        return {
            queryImpl: function (s) {
                return function (l) {
                    return map(map3(Data_Tuple_T2.proj2))(queryImpl(s)(l));
                };
            }
        };
    };
};
var ordLocalId = Data_Ord.ordInt;
var newtypeLocalId_ = {
    Coercible0: function () {
        return undefined;
    }
};
var mergeOrderedMultiSetList$prime = function (dictMerge) {
    var merge = Restaumatic_Form_Internal.merge(dictMerge);
    return {
        merge: function (xs) {
            return function (l) {
                return merge(map3(Data_Tuple_T2.fromTuple)(Data_OrderedMultiSet.toOccurArray(xs)))(l);
            };
        }
    };
};
var mergeOMapList$prime = function (dictMerge) {
    var merge = Restaumatic_Form_Internal.merge(dictMerge);
    return {
        merge: function (xs) {
            return function (l) {
                return merge(map3(Data_Tuple_T2.fromTuple)(Data_Map_Ordered.toArray(xs)))(l);
            };
        }
    };
};
var mergeMapList$prime = function (dictMerge) {
    var merge = Restaumatic_Form_Internal.merge(dictMerge);
    return {
        merge: function (xs) {
            return function (l) {
                return merge(map3(Data_Tuple_T2.fromTuple)(toUnfoldable(xs)))(l);
            };
        }
    };
};
var listLikeList$prime = {
    withListD: function (f) {
        return f;
    }
};
var itemLikeItem = {
    key: function (v) {
        return v.key;
    },
    subform: function (v) {
        return v.subform;
    },
    toItemE: pure1
};
var isTextFieldListItem = function (dictIsTextField) {
    var textInput = Restaumatic_Form_Internal.textInput(dictIsTextField);
    return {
        textInput: function (v) {
            return textInput(v.subform);
        }
    };
};
var initializeSomeInitialValu = function (dictInitialize) {
    var makeImpl = Restaumatic_Form_Internal.makeImpl(dictInitialize);
    return function (dictMerge) {
        var merge = Restaumatic_Form_Internal.merge(dictMerge);
        return {
            makeImpl: function (p) {
                return function (opts) {
                    return function (meta) {
                        return function (v) {
                            return function (initializer) {
                                return bind2(makeImpl(p)(opts)(meta)(Restaumatic_Form_Internal.NoInitialValue.value)(initializer))(function (field) {
                                    return discard2(liftEffect(merge(v.value0)(field)))(function () {
                                        return pure2(field);
                                    });
                                });
                            };
                        };
                    };
                };
            }
        };
    };
};
var initializeNoInitializerLi = function (dictInitialize) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithDefaultInitializer(dictInitialize)({
            item: function (v) {
                return Restaumatic_Form_Internal.NoInitializer.value;
            }
        })
    };
};
var initializeMetadataInitial = function (dictMakeWithMetadataInitializer) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithMetadataInitializer(dictMakeWithMetadataInitializer)
    };
};
var initializeInitialValueIni = function (dictMakeWithInitialValueInitializer) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithInitialValueInitializer(dictMakeWithInitialValueInitializer)
    };
};
var hasLabelListItem = function (dictHasLabel) {
    var getLabel = Restaumatic_Form_Internal.getLabel(dictHasLabel);
    return {
        getLabel: function (v) {
            return getLabel(v.subform);
        }
    };
};
var hasFieldIdListItem = function (dictShow) {
    return {
        getFieldId: function (v) {
            return Restaumatic_Form_Internal.fieldPathToString(v.name);
        }
    };
};
var hasFieldIdList$prime = {
    getFieldId: function (v) {
        return Restaumatic_Form_Internal.fieldPathToString(v.name);
    }
};
var hasFieldIdDelayedItem = function (dictShow) {
    return {
        getFieldId: function (v) {
            return Restaumatic_Form_Internal.fieldPathToString(v.name);
        }
    };
};
var genericLocalId_ = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var eqLocalId = Data_Eq.eqInt;
var eqListItem = {
    eq: Unsafe_Reference.unsafeRefEq
};
var eqMaybe = /* #__PURE__ */ Data_Maybe.eqMaybe(eqListItem);
var encodeLocalId = Foreign_Generic_Class.intEncode;
var decodeLocalId = {
    unsafeDecode: function ($554) {
        return wrap(Unscramble.decodeInt($554));
    }
};
var decodeLocalId1 = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericLocalId_)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "LocalId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode)))(Foreign_Generic_Class.genericCountArgsArgument))
};
var addErrorsList$prime = function (dictAddErrors) {
    var addErrors = Restaumatic_Form_Internal.addErrors(dictAddErrors);
    return {
        addErrors: function (errors) {
            return function (v) {
                return function __do() {
                    var items = read(v.items)();
                    return forWithIndex_(Data_Map_Ordered.toArray(items))(function (idx) {
                        return function (v1) {
                            var fieldPath = Restaumatic_Form_Internal.fieldPathToString(v1.value1.name);
                            var errorsPath = Restaumatic_Form_Internal.fieldPathToString(append1(v.name)([ show(idx) ]));
                            var newKey = Data_String_Common.replace(errorsPath)(fieldPath);
                            var remapKey = function (v2) {
                                var v3 = Data_String_CodePoints.indexOf(errorsPath)(v2.value0);
                                if (v3 instanceof Data_Maybe.Just && v3.value0 === 0) {
                                    return new Data_Tuple.Tuple(newKey(v2.value0), v2.value1);
                                };
                                return v2;
                            };
                            var errors$prime = fromFoldable(map3(remapKey)(toAscUnfoldable(errors)));
                            return addErrors(errors$prime)(v1.value1.subform);
                        };
                    })();
                };
            };
        }
    };
};
var withListD = function (dict) {
    return dict.withListD;
};
var listLikeDelayed = function (dictListLike) {
    var withListD1 = withListD(dictListLike);
    return {
        withListD: function (f) {
            return function (v) {
                return bind1(v)(withListD1(f));
            };
        }
    };
};
var listLikeUndoable = function (dictListLike) {
    var withListD1 = withListD(dictListLike);
    return {
        withListD: function (f) {
            var $555 = withListD1(f);
            return function ($556) {
                return $555(Restaumatic_Form_Undoable.subform($556));
            };
        }
    };
};
var listLikeWithExtra = function (dictListLike) {
    var withListD1 = withListD(dictListLike);
    return {
        withListD: function (f) {
            var $557 = withListD1(f);
            return function ($558) {
                return $557(Restaumatic_Form_WithExtra.subform($558));
            };
        }
    };
};
var toListE = function (dictListLike) {
    var $559 = withListD(dictListLike)(pure3);
    return function ($560) {
        return readDynamic($559($560));
    };
};
var toItemE = function (dict) {
    return dict.toItemE;
};
var subform = function (dict) {
    return dict.subform;
};
var subform1 = /* #__PURE__ */ subform(itemLikeItem);
var hasErrorsListItem = function (dictHasErrors) {
    var displayedErrors = Restaumatic_Form_Internal.displayedErrors(dictHasErrors);
    return {
        displayedErrors: function (f) {
            return displayedErrors(subform1(f));
        }
    };
};
var itemLikeDelayedDelayedIte = {
    key: function (v) {
        return v.key;
    },
    subform: function (v) {
        return map4(subform1)(v.item);
    },
    toItemE: function (v) {
        return readDelayed(v.item);
    }
};
var subform2 = /* #__PURE__ */ subform(itemLikeDelayedDelayedIte);
var hasErrorsDelayedItem = function (dictHasErrors) {
    var displayedErrors = Restaumatic_Form_Internal.displayedErrors(Restaumatic_Form_Internal.hasErrorsDelayed(dictHasErrors));
    return {
        displayedErrors: function (f) {
            return displayedErrors(subform2(f));
        }
    };
};
var hasFieldDelayedDelayedIte = function (dictHasField) {
    var getField = Data_Record.getField(Restaumatic_Form_Delayed.hasFieldDelayedDelayed(dictHasField));
    return {
        getField: function (label) {
            var $561 = getField(label);
            return function ($562) {
                return $561(subform2($562));
            };
        }
    };
};
var mergeDelayedItem = function (dictMerge) {
    var merge = Restaumatic_Form_Internal.merge(Restaumatic_Form_Internal.mergeDelayed(dictMerge));
    return {
        merge: function (x) {
            var $563 = merge(x);
            return function ($564) {
                return $563(subform2($564));
            };
        }
    };
};
var queryDelayedItem = function (dictQuery) {
    var queryImpl = Restaumatic_Form_Query.queryImpl(Restaumatic_Form_Query.queryDelayed(dictQuery));
    return {
        queryImpl: function (s) {
            var $565 = queryImpl(s);
            return function ($566) {
                return $565(subform2($566));
            };
        }
    };
};
var numItems = function (dictListLike) {
    return withListD(dictListLike)(function (v) {
        return map1(Data_Map_Ordered.size)(Specular_Ref.value(v.items));
    });
};
var newtypeListItem = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeList = {
    Coercible0: function () {
        return undefined;
    }
};
var newItem = function (dictShow) {
    var show1 = Data_Show.show(dictShow);
    return function (dictListLike) {
        var toListE1 = toListE(dictListLike);
        return function (dl) {
            return function (key2) {
                return function (iv) {
                    return function __do() {
                        var v = toListE1(dl)();
                        var v1 = Specular_FRP_Host.runHost(bind2(read1(v.context))(function (ctx) {
                            return bind2(v.init(v)({
                                name: append1(v.name)([ show1(key2) ])
                            })(key2)(iv))(function (item) {
                                return discard2(liftEffect(v.addContext(ctx)(subform1(item))))(function () {
                                    return pure2(item);
                                });
                            });
                        }))();
                        return {
                            name: v1.value0.name,
                            key: v1.value0.key,
                            subform: v1.value0.subform,
                            "delete": v1["value0"]["delete"],
                            cleanup: v1.value1
                        };
                    };
                };
            };
        };
    };
};
var mergeArrayT2List$primeSomeInit = function (dictOrd) {
    var fromArray = Data_Map_Ordered.fromArray(dictOrd);
    return function (dictShow) {
        var newItem1 = newItem(dictShow)(listLikeList$prime);
        return {
            merge: function (xs) {
                return function (v) {
                    return function __do() {
                        var oldItems = read(v.items)();
                        traverse_(function (v1) {
                            return v1.cleanup;
                        })(oldItems)();
                        var newItems = $$for(xs)(function (v1) {
                            return map5(Data_Tuple.Tuple.create(v1.value0))(newItem1(v)(v1.value0)(new Restaumatic_Form_Internal.SomeInitialValue(v1.value1)));
                        })();
                        return write(v.items)(fromArray(newItems))();
                    };
                };
            }
        };
    };
};
var moveItem = function (dictListLike) {
    var toListE1 = toListE(dictListLike);
    return function (dl) {
        return function (oldIndex) {
            return function (newIndex) {
                return function __do() {
                    var v = toListE1(dl)();
                    return modify(v.items)(function (items) {
                        return Data_Maybe.fromMaybe(items)(Data_Map_Ordered.move(oldIndex)(newIndex)(items));
                    })();
                };
            };
        };
    };
};
var mergeNonEmptyArrayList = function (dictMerge) {
    return {
        merge: (function () {
            var $567 = Restaumatic_Form_Internal.merge(dictMerge);
            return function ($568) {
                return $567(Data_Array_NonEmpty.toArray($568));
            };
        })()
    };
};
var mergeNewtypeList = function () {
    return function (dictMerge) {
        var merge = Restaumatic_Form_Internal.merge(dictMerge);
        return {
            merge: function (xs) {
                return function (l) {
                    return merge(unwrap(xs))(l);
                };
            }
        };
    };
};
var mergeItem = function (dictMerge) {
    var merge = Restaumatic_Form_Internal.merge(dictMerge);
    return {
        merge: function (x) {
            return function (v) {
                return merge(x)(v.subform);
            };
        }
    };
};
var mergeArrayT2List$primeNoInitia = function (dictShow) {
    var newItem1 = newItem(dictShow)(listLikeList$prime);
    return function (dictOrd) {
        var fromArray = Data_Map_Ordered.fromArray(dictOrd);
        return function (dictMerge) {
            var merge = Restaumatic_Form_Internal.merge(mergeItem(dictMerge));
            return {
                merge: function (xs) {
                    return function (v) {
                        return function __do() {
                            var oldItems = read(v.items)();
                            traverse_(function (v1) {
                                return v1.cleanup;
                            })(oldItems)();
                            var newItems = $$for(xs)(function (v1) {
                                return function __do() {
                                    var item = newItem1(v)(v1.value0)(Restaumatic_Form_Internal.NoInitialValue.value)();
                                    merge(v1.value1)(item)();
                                    return new Data_Tuple.Tuple(v1.value0, item);
                                };
                            })();
                            return write(v.items)(fromArray(newItems))();
                        };
                    };
                }
            };
        };
    };
};
var key = function (dict) {
    return dict.key;
};
var key1 = /* #__PURE__ */ key(itemLikeItem);
var mergePlainArray = function (dictShow) {
    return function (dictOrd) {
        var fromArray = Data_Map_Ordered.fromArray(dictOrd);
        return function (dictMerge) {
            var merge = Restaumatic_Form_Internal.merge(mergeItem(dictMerge));
            return function (v) {
                return function (makeItem) {
                    return function (xs) {
                        return function __do() {
                            var oldItems = read(v.items)();
                            var reusedItems = $$for(Data_Array.zip(Data_Map_Ordered.values(oldItems))(xs))(function (v1) {
                                return function __do() {
                                    merge(v1.value1)(v1.value0)();
                                    return v1.value0;
                                };
                            })();
                            var extraItems = $$for(Data_Array.drop(Data_Map_Ordered.size(oldItems))(xs))(function (v1) {
                                return function __do() {
                                    var k = v.generateId();
                                    return makeItem(k)(v1)();
                                };
                            })();
                            for_1(Data_Array.drop(Data_Array.length(xs))(Data_Map_Ordered.values(oldItems)))(function (v1) {
                                return v1.cleanup;
                            })();
                            return write(v.items)(fromArray(Data_Array.zip(append1(Data_Map_Ordered.keys(oldItems))(map3(key1)(extraItems)))(append1(reusedItems)(extraItems))))();
                        };
                    };
                };
            };
        };
    };
};
var mergeArrayList$primeNoInitialV = function (dictShow) {
    var newItem1 = newItem(dictShow)(listLikeList$prime);
    var mergePlainArray1 = mergePlainArray(dictShow);
    return function (dictOrd) {
        var mergePlainArray2 = mergePlainArray1(dictOrd);
        return function (dictMerge) {
            var merge = Restaumatic_Form_Internal.merge(mergeItem(dictMerge));
            var mergePlainArray3 = mergePlainArray2(dictMerge);
            return {
                merge: function (xs) {
                    return function (field) {
                        var makeItem = function (k) {
                            return function (v) {
                                return function __do() {
                                    var item = newItem1(field)(k)(Restaumatic_Form_Internal.NoInitialValue.value)();
                                    merge(v)(item)();
                                    return item;
                                };
                            };
                        };
                        return mergePlainArray3(field)(makeItem)(xs);
                    };
                }
            };
        };
    };
};
var mergeArrayList$primeSomeInitia = function (dictShow) {
    var newItem1 = newItem(dictShow)(listLikeList$prime);
    var mergePlainArray1 = mergePlainArray(dictShow);
    return function (dictOrd) {
        var mergePlainArray2 = mergePlainArray1(dictOrd);
        return function (dictMerge) {
            var mergePlainArray3 = mergePlainArray2(dictMerge);
            return {
                merge: function (xs) {
                    return function (field) {
                        var makeItem = function (k) {
                            return function (v) {
                                return newItem1(field)(k)(new Restaumatic_Form_Internal.SomeInitialValue(v));
                            };
                        };
                        return mergePlainArray3(field)(makeItem)(xs);
                    };
                }
            };
        };
    };
};
var toDelayedItem = function (item) {
    return {
        key: key1(item),
        name: (unwrap(item)).name,
        item: pure4(item)
    };
};
var itemForKey = function (dictOrd) {
    var lookup = Data_Map_Ordered.lookup(dictOrd)(dictOrd.Eq0());
    return function (dictListLike) {
        var withListD1 = withListD(dictListLike);
        return function (d) {
            return function (k) {
                return Data_Function.flip(withListD1)(d)(function (v) {
                    return map1(lookup(k))(Specular_Ref.value(v.items));
                });
            };
        };
    };
};
var hasFieldItem = function (dictHasField) {
    var getField = Data_Record.getField(dictHasField);
    return {
        getField: function (label) {
            return function (v) {
                return getField(label)(v.subform);
            };
        }
    };
};
var generateLocalId = {
    newIdGenerator: function __do() {
        var next = Effect_Ref["new"](0)();
        return map5(LocalId)(Effect_Ref.modify(function (v) {
            return add(v)(1);
        })(next));
    }
};
var dumpStateList = function (dictEncodeWithOptions) {
    var encode = Foreign_Generic_Class.encode(recordEncode(encodeRecordCons2(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(recordEncode(encodeRecordCons3(dictEncodeWithOptions)))))));
    return function (dictDumpState) {
        var dumpState = Restaumatic_Form_Internal.dumpState(dictDumpState);
        return {
            dumpState: function (v) {
                return bind1(Specular_Ref.value(v.items))(function (items) {
                    return map1(encode)(sequenceRecord1({
                        items: for1(Data_Map_Ordered.values(items))(function (v1) {
                            return sequenceRecord2({
                                key: pure3(v1.key),
                                subform: dumpState(v1.subform)
                            });
                        })
                    }));
                });
            }
        };
    };
};
var displayedItems = function (dictListLike) {
    return withListD(dictListLike)(function (v) {
        return map1(Data_Map_Ordered.values)(Specular_Ref.value(v.items));
    });
};
var displayList$prime = function (dictShow) {
    var keyedList = Specular_KeyedList.keyedList(dictShow);
    return function (dictListLike) {
        var displayedItems1 = displayedItems(dictListLike);
        return function (l) {
            return function (renderItem) {
                return keyedList("div")([  ])(displayedItems1(l))(key1)(function (ix) {
                    return function (item) {
                        return {
                            tag: "div",
                            props: [  ],
                            body: renderItem(ix)(item)
                        };
                    };
                });
            };
        };
    };
};
var displayList = function (dictMonadFRP) {
    var dynamicListWithIndex_ = Specular_FRP_List.dynamicListWithIndex_(dictMonadFRP);
    return function (dictMonadReplace) {
        var dynamicListWithIndex_1 = dynamicListWithIndex_(dictMonadReplace);
        var withDynamic_ = Specular_FRP_Replaceable.withDynamic_(dictMonadReplace)(dictMonadFRP);
        return function (dictListLike) {
            var displayedItems1 = displayedItems(dictListLike);
            return function (l) {
                return function (renderItem) {
                    return dynamicListWithIndex_1(displayedItems1(l))(function (ix) {
                        return function (ditem) {
                            return withDynamic_(ditem)(renderItem(pure3(ix)));
                        };
                    });
                };
            };
        };
    };
};
var displayKey = function (dictOrd) {
    var itemForKey1 = itemForKey(dictOrd);
    return function (dictMonadFRP) {
        var withUniqDynamic_ = Specular_FRP_Extra.withUniqDynamic_(dictMonadFRP);
        var traverse_1 = Data_Foldable.traverse_(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(Data_Foldable.foldableMaybe);
        return function (dictMonadReplace) {
            var withUniqDynamic_1 = withUniqDynamic_(dictMonadReplace)(eqMaybe);
            return function (dictListLike) {
                var itemForKey2 = itemForKey1(dictListLike);
                return function (field) {
                    return function (k) {
                        return function (display) {
                            return withUniqDynamic_1(itemForKey2(field)(k))(traverse_1(display));
                        };
                    };
                };
            };
        };
    };
};
var deleteItemByKey = function (dictOrd) {
    var lookup = Data_Map_Ordered.lookup(dictOrd)(dictOrd.Eq0());
    var $$delete = Data_Map_Ordered["delete"](dictOrd);
    return function (dictListLike) {
        var toListE1 = toListE(dictListLike);
        return function (dl) {
            return function (key_) {
                return function __do() {
                    var v = toListE1(dl)();
                    var items_ = read(v.items)();
                    var item = lookup(key_)(items_);
                    return for_2(item)(function (v1) {
                        return function __do() {
                            write(v.items)($$delete(key_)(items_))();
                            return v1.cleanup();
                        };
                    })();
                };
            };
        };
    };
};
var initializeNoInitialValueR = function (dictGenerateId) {
    var newIdGenerator = Restaumatic_Form_GenerateId.newIdGenerator(dictGenerateId);
    return function (dictAddContext) {
        var addContext = Restaumatic_Form_Internal.addContext(dictAddContext);
        return function (dictShow) {
            return function (dictOrd) {
                var mempty1 = Data_Monoid.mempty(Data_Map_Ordered.monoidOMap(dictOrd));
                var deleteItemByKey1 = deleteItemByKey(dictOrd)(listLikeList$prime);
                return function (dictInitialize) {
                    var makeImpl = Restaumatic_Form_Internal.makeImpl(dictInitialize);
                    return function (dictMaybeGetMetadata) {
                        var maybeGetMetadata = Restaumatic_Form_Internal.maybeGetMetadata(dictMaybeGetMetadata);
                        return function (dictFromDefaults) {
                            var fromDefaults = Data_NamedParams.fromDefaults(dictFromDefaults);
                            return {
                                makeImpl: function (p) {
                                    return function (opts) {
                                        return function (meta) {
                                            return function (v) {
                                                return function (initializer) {
                                                    return liftEffect(function __do() {
                                                        var items = $$new(mempty1)();
                                                        var generateId = newIdGenerator();
                                                        var context = $$new(mempty)();
                                                        var params = fromDefaults({
                                                            presentWhen: function (v1) {
                                                                return pure3(true);
                                                            },
                                                            label: Restaumatic_Form_Internal.liftMaybe(Data_Maybe.Nothing.value),
                                                            options: Restaumatic_Form_Internal.liftMaybe(Data_Maybe.Nothing.value)
                                                        })(initializer);
                                                        var init = function (parent) {
                                                            return function (itemOpts) {
                                                                return function (key2) {
                                                                    return function (iv) {
                                                                        return fixDelayed(function (item) {
                                                                            var ditem = {
                                                                                key: key2,
                                                                                name: itemOpts.name,
                                                                                item: item
                                                                            };
                                                                            return bind2(makeImpl(p)(itemOpts)(maybeGetMetadata(meta))(iv)(params.item(ditem)))(function (subform3) {
                                                                                return pure2({
                                                                                    name: itemOpts.name,
                                                                                    key: key2,
                                                                                    subform: subform3,
                                                                                    cleanup: pure1(Data_Unit.unit),
                                                                                    "delete": deleteItemByKey1(parent)(key2)
                                                                                });
                                                                            });
                                                                        });
                                                                    };
                                                                };
                                                            };
                                                        };
                                                        return {
                                                            name: opts.name,
                                                            items: items,
                                                            init: init,
                                                            generateId: generateId,
                                                            addContext: addContext,
                                                            context: context,
                                                            presentWhen: function ($569) {
                                                                return params.presentWhen(toDelayedItem($569));
                                                            }
                                                        };
                                                    });
                                                };
                                            };
                                        };
                                    };
                                }
                            };
                        };
                    };
                };
            };
        };
    };
};
var deleteItem = function (dictItemLike) {
    var toItemE1 = toItemE(dictItemLike);
    return function (item) {
        return function __do() {
            var v = toItemE1(item)();
            return v["delete"]();
        };
    };
};
var addItem$prime = function (dictOrd) {
    var insert = Data_Map_Ordered.insert(dictOrd);
    return function (dictShow) {
        var newItem1 = newItem(dictShow)(listLikeList$prime);
        return function (dictListLike) {
            var toListE1 = toListE(dictListLike);
            return function (dl) {
                return function (k) {
                    return function (iv) {
                        return function __do() {
                            var v = toListE1(dl)();
                            var item = newItem1(v)(k)(new Restaumatic_Form_Internal.SomeInitialValue(iv))();
                            modify(v.items)(insert(k)(item))();
                            return item;
                        };
                    };
                };
            };
        };
    };
};
var pushItem$prime = function (dictOrd) {
    var addItem$prime1 = addItem$prime(dictOrd);
    return function (dictShow) {
        var addItem$prime2 = addItem$prime1(dictShow)(listLikeList$prime);
        return function (dictListLike) {
            var toListE1 = toListE(dictListLike);
            return function (dl) {
                return function (iv) {
                    return function __do() {
                        var v = toListE1(dl)();
                        var k = v.generateId();
                        return addItem$prime2(v)(k)(iv)();
                    };
                };
            };
        };
    };
};
var addItem = function (dictOrd) {
    var insert = Data_Map_Ordered.insert(dictOrd);
    return function (dictShow) {
        var newItem1 = newItem(dictShow)(listLikeList$prime);
        return function (dictListLike) {
            var toListE1 = toListE(dictListLike);
            return function (dl) {
                return function (k) {
                    return function __do() {
                        var v = toListE1(dl)();
                        var item = newItem1(v)(k)(Restaumatic_Form_Internal.NoInitialValue.value)();
                        modify(v.items)(insert(k)(item))();
                        return item;
                    };
                };
            };
        };
    };
};
var pushItem = function (dictOrd) {
    var addItem1 = addItem(dictOrd);
    return function (dictShow) {
        var addItem2 = addItem1(dictShow)(listLikeList$prime);
        return function (dictListLike) {
            var toListE1 = toListE(dictListLike);
            return function (dl) {
                return function __do() {
                    var v = toListE1(dl)();
                    var k = v.generateId();
                    return addItem2(v)(k)();
                };
            };
        };
    };
};
var pushItem_ = function (dictOrd) {
    var pushItem1 = pushItem(dictOrd);
    return function (dictShow) {
        var pushItem2 = pushItem1(dictShow);
        return function (dictListLike) {
            var pushItem3 = pushItem2(dictListLike);
            return function (l) {
                return $$void(pushItem3(l));
            };
        };
    };
};
var addContextList = function (dictAddContext) {
    var addContext = Restaumatic_Form_Internal.addContext(dictAddContext);
    return {
        addContext: function (ctx) {
            return function (v) {
                return function __do() {
                    modify(v.context)(function (v1) {
                        return append2(ctx)(v1);
                    })();
                    var items = readRef(v.items)();
                    return for_3(items)(function (item) {
                        return addContext(ctx)(subform1(item));
                    })();
                };
            };
        }
    };
};
export {
    key,
    subform,
    toItemE,
    withListD,
    LocalId,
    List,
    toListE,
    ListItem,
    DelayedItem,
    toDelayedItem,
    mergePlainArray,
    numItems,
    itemForKey,
    newItem,
    pushItem,
    pushItem$prime,
    addItem,
    addItem$prime,
    pushItem_,
    deleteItemByKey,
    deleteItem,
    displayedItems,
    moveItem,
    displayList,
    displayList$prime,
    displayKey,
    genericLocalId_,
    newtypeLocalId_,
    eqLocalId,
    ordLocalId,
    showLocalId,
    encodeLocalId,
    decodeLocalId1,
    decodeLocalId,
    generateLocalId,
    newtypeList,
    hasFieldIdList$prime,
    listLikeList$prime,
    listLikeWithExtra,
    listLikeUndoable,
    listLikeDelayed,
    newtypeListItem,
    hasFieldItem,
    queryListItem,
    mergeItem,
    hasErrorsListItem,
    isTextFieldListItem,
    hasLabelListItem,
    hasFieldIdListItem,
    eqListItem,
    itemLikeItem,
    itemLikeDelayedDelayedIte,
    hasFieldDelayedDelayedIte,
    queryDelayedItem,
    mergeDelayedItem,
    hasErrorsDelayedItem,
    hasFieldIdDelayedItem,
    initializeNoInitialValueR,
    initializeSomeInitialValu,
    initializeInitialValueIni,
    initializeNoInitializerLi,
    initializeMetadataInitial,
    mergeOMapList$prime,
    mergeMapList$prime,
    mergeOrderedMultiSetList$prime,
    mergeArrayT2List$primeNoInitia,
    mergeArrayT2List$primeSomeInit,
    mergeArrayList$primeSomeInitia,
    mergeArrayList$primeNoInitialV,
    mergeNonEmptyArrayList,
    mergeNewtypeList,
    queryArrayT2List$prime,
    queryArrayList$prime,
    queryOMapList$prime,
    queryMapList$prime,
    queryNonEmptyArrayList$primePa,
    queryList$prime,
    addContextList,
    dumpStateList,
    addErrorsList$prime,
    toHelperList$prime,
    toRecordHelperList$prime,
    toFillFormTypeLocalId
};
